import React, { useEffect, useState } from 'react'

import { useT } from '../i18n'
import { LOCAL_WRITE_FAILED_EVENT, type LocalWriteFailedDetail } from '../offline/bulkStore'

// findings #70 / #75: a local save that fails (device storage full or blocked)
// used to be dropped with a console warning only. Show it to the user instead.
export default function LocalWriteFailedBanner(): React.ReactElement | null {
  const t = useT()
  const [failure, setFailure] = useState<LocalWriteFailedDetail | null>(null)

  useEffect(() => {
    const onFailure = (event: Event) => {
      const detail = (event as CustomEvent<LocalWriteFailedDetail>).detail
      setFailure(detail ?? { key: '', message: '' })
    }
    window.addEventListener(LOCAL_WRITE_FAILED_EVENT, onFailure)
    return () => window.removeEventListener(LOCAL_WRITE_FAILED_EVENT, onFailure)
  }, [])

  if (!failure) return null

  return (
    <div
      role="alert"
      data-testid="local-write-failed-banner"
      style={{
        position: 'fixed',
        left: 16,
        right: 16,
        bottom: 16,
        zIndex: 2000,
        display: 'flex',
        gap: 12,
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px 16px',
        borderRadius: 10,
        background: '#fef2f2',
        border: '1px solid #fecaca',
        color: '#991b1b',
        fontSize: 14,
        boxShadow: '0 10px 25px rgba(15, 23, 42, 0.15)'
      }}
    >
      <span>{t('app.localWriteFailed')}</span>
      <button type="button" onClick={() => setFailure(null)} style={{ flexShrink: 0 }}>
        {t('common.close')}
      </button>
    </div>
  )
}
